import * as XLSX from 'xlsx';

export interface ExcelReportDTO {
  fileName: string;
  columns: string[];
  rows: any[][];
  rowStyles?: {
    bgColor?: string;
    fontColor?: string;
    bold?: boolean;
  }[];
}

function saveAs(blob: Blob, fileName: string) {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName; // El nombre con la extensión, ej: 'mi_documento.pdf'
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); // Limpia el enlace del DOM
  URL.revokeObjectURL(link.href); // Libera la memoria del objeto URL
}

export function excelGenerator(dto: ExcelReportDTO) {
  const { fileName, columns, rows, rowStyles } = dto;

  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);

  // --- Agregar encabezados ---
  XLSX.utils.sheet_add_aoa(worksheet, [columns], { origin: 'A1' });

  // --- Estilos para encabezados ---
  columns.forEach((_, idx) => {
    const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: idx })];
    cell.s = {
      fill: { fgColor: { rgb: '4F81BD' } },
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      alignment: { horizontal: 'center' }
    };
  });

  // --- Agregar filas ---
  XLSX.utils.sheet_add_aoa(worksheet, rows, { origin: 'A2' });

  // --- Estilos por fila ---
  if (rowStyles) {
    rows.forEach((row, rowIndex) => {
      const style = rowStyles[rowIndex];
      if (!style) return;

      row.forEach((_, colIndex) => {
        const cell =
          worksheet[XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIndex })];

        if (!cell) return;

        cell.s = {
          fill: style.bgColor
            ? { fgColor: { rgb: style.bgColor.replace('#', '') } }
            : undefined,
          font: {
            bold: style.bold ?? false,
            color: style.fontColor
              ? { rgb: style.fontColor.replace('#', '') }
              : undefined
          }
        };
      });
    });
  }

  // --- Crear libro ---
  const workbook: XLSX.WorkBook = {
    Sheets: { Reporte: worksheet },
    SheetNames: ['Reporte']
  };

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
    cellStyles: true
  });

  const blob = new Blob([excelBuffer], {
    type: 'application/octet-stream'
  });

  saveAs(blob, `${fileName}.xlsx`);
}
